import {bootstrapApplication} from '@angular/platform-browser';
import {AppComponent} from './app/app.component';
import {rootAppConfig} from './app/app.config';
import {environment} from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  Sentry.init({
    dsn: environment.sentryDsn
  })
}

bootstrapApplication(AppComponent, rootAppConfig).catch(err => console.error(err));
